/**
 * Single source of truth for all global search filter keys and routing (legislation + workspace document).
 */

// ----- Legislation filters (searchQuery.filters) -----

/** Root filter key for legislation source selection (e.g. retsinformation, arvid). Stored in searchQuery.filters. */
export const LEGISLATION_SOURCE_FILTER_KEY = "datasource";

// ----- Workspace document filters (searchQuery.workspaceDocumentFilters) -----

/** Prefix for filter keys that target workspace document filters. Stripped when storing; used only for routing in updateFilter. */
export const WORKSPACE_DOCUMENT_FILTER_PREFIX = "wd::";

/** Reserved filter key for document title in workspace document search (sent to backend). */
export const WORKSPACE_DOCUMENT_TITLE_FILTER_KEY = "document_title";